module.exports = __webpack_public_path__ + "img/lb-4.01797d20.jpg";